import moment from 'moment-timezone'

export const formatTimestamp = (
  timestamp: string | number,
  timezone: string,
  formatType: string = 'DD MMM YYYY HH:mm',
) => {
  return moment(Number(timestamp)).tz(timezone).format(formatType)
}
